import { Box, styled } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { ProductInventory } from '@setvi/shared/interfaces';
import { Customer } from 'Services/Mongo/Types';

export interface LocationProps {
  row: ProductInventory;
  getWarehouseLocation: (warehouse: ProductInventory['warehouse']) => string;
  selectedCustomer: Customer;
}

const Badge = styled(Box)(({ theme: { spacing } }) => ({
  backgroundColor: '#EBF5FF',
  color: TextColor.Blue,
  borderRadius: 16,
  lineHeight: '16px',
  fontWeight: 600,
  padding: spacing(2),
  fontSize: 12,
  minWidth: 'max-content',
  marginLeft: spacing(2)
}));

export const Location = ({
  row,
  selectedCustomer,
  getWarehouseLocation
}: LocationProps) => (
  <Box display="flex" alignItems="center">
    <SText
      size="sm"
      lineHeight="20px"
      title={getWarehouseLocation(row.warehouse)}
    />
    {row.warehouseId === selectedCustomer?.warehouse?.code && (
      <Badge>Home DC</Badge>
    )}
  </Box>
);
